export const AUTH_ONBOARDING_VIDEO = 'auth-onboarding-video';
